import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_EMPLOYERS_ENDPOINT: EMPLOYERS_ENDPOINT,
} = process.env;

export const url = `${ONBOARDING_API_HOST}${EMPLOYERS_ENDPOINT}`;

export default class EmployersAPI {
  static getEmployers = token => APIClient.get(url, token).then(response => response.data);
}
